import { PaymentMethodPriority } from "../enums";

export class PaymentMethodUtil {
    static getColors(paymentMethodPriority: keyof typeof PaymentMethodPriority) {
        const color = paymentMethodPriority === PaymentMethodPriority?.Primary ? '#579836' : '#6A7AB5';
        const bgColor = paymentMethodPriority === PaymentMethodPriority?.Primary ? '#EEF7EA' : '#ECF0FF';
        return {
            color,
            bgColor,
        };
    }
}